module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "SalesforceLogo.01788cc7.svg";